import logo from "./logo.svg";
import { BrowserRouter as Router, Route, Routes, Link } from "react-router-dom";
import LandingPage from "./pages/landing";
import Terms from "./pages/termsAndServices";
import PrivacyPolicy from "./pages/privacyPolicy";
import RevokeAcess from "./pages/revokeAccess";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/terms-and-services" element={<Terms />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/delete-data" element={<RevokeAcess />} />
      </Routes>
    </Router>
  );
}

export default App;
